import * as yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import React from 'react';
import { yupErrorMsg } from '../../../../../components/atoms/const';
import api from '../../../../../components/api';

function usePartnersContactPerson(contactIdFromParent?: number, formikParent? :any) {
  const { partnerId, contactId } = useParams();

  // Checking where this form used on 'add' or 'edit' url
  const isEdit:boolean = React.useMemo(
    () => window.location.pathname.split('/')[2] === 'edit',
    [window.location.pathname],
  );

  // Get Contact Person Detail from Partner Contact Person List
  const { data: partnerRes, isLoading: partnerLoad, refetch } = useQuery(
    ['getById', 'partner', partnerId],
    () => api.partner.getById(partnerId!),
    {
      enabled: !!partnerId,
    },
  );
  const contactPersonById = React.useMemo(
    () => partnerRes?.data?.data?.contactPerson.find((contact) => contact.id.toString() === (contactId ?? contactIdFromParent?.toString())),
    [partnerRes, contactIdFromParent],
  );

  // Update Contact Person
  const navigation = useNavigate();
  const { mutate: updateContact, isLoading: updateLoad } = useMutation(api.contacts.update, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      alert('success');
      if (isEdit) navigation(`/partners/${partnerId}`);
      if (!isEdit) refetch().catch((e) => console.log('err', e));
      console.log(data);
    },
    onError: (error) => console.log(error),
  });

  const yupSchema = yup.object().shape({
    firstname: yup.string().required(yupErrorMsg.FIRST_NAME_EMPTY),
    lastname: yup.string().required(yupErrorMsg.LAST_NAME_EMPTY),
    email: yup.string().email(yupErrorMsg.EMAIL_INCORRECT_FORMAT).required(yupErrorMsg.EMAIL_EMPTY),
    phoneNumber: yup.string().required(yupErrorMsg.PHONE_NUMBER_EMPTY),
    position: yup.string().required(yupErrorMsg.POSITION_EMPTY),
  });

  const formik = useFormik({
    initialValues: {
      firstname: '',
      lastname: '',
      email: '',
      phoneNumber: '',
      position: '',
    },
    validationSchema: yupSchema,
    onSubmit: (values) => {
      const id = contactIdFromParent ?? contactId;
      if (id) {
        updateContact({ id: Number(id), ...values });
      }
    },
  });

  const currentFormik = React.useMemo(() => formikParent ?? formik, [formikParent, formik]);

  // auto fill form with contact person on partner
  React.useEffect(() => {
    if (contactPersonById) {
      currentFormik.setFieldValue('firstname', contactPersonById.firstname ?? '');
      currentFormik.setFieldValue('lastname', contactPersonById.lastname ?? '');
      currentFormik.setFieldValue('email', contactPersonById.email ?? '');
      currentFormik.setFieldValue('phoneNumber', contactPersonById.phoneNumber ?? '');
      currentFormik.setFieldValue('position', contactPersonById.position ?? '');
    }
  }, [contactPersonById]);

  return {
    formik: currentFormik,
    partner: {
      isLoading: partnerLoad,
    },
    contactPersonById,
    partnerId,
    isEdit,
    updateLoad,
  };
}

export default usePartnersContactPerson;
